import { anchorSmooth } from './modules/anchorSmooth';
import { aosConfig } from './modules/aosConfig';
import { selectFirstTextColorChange } from './modules/contactConfig';
import { indexMvTextAnimation } from './modules/gsapAnimation';
import { headerColorChange } from './modules/headerColorChange';
import { hamburgerMenuToggle } from './modules/headerUiControl';
import { imgParallax } from './modules/imgParallax';
import { lenisConfig } from './modules/lenisConfig';
import { pageTop } from './modules/pageTop';
import { scrollHint } from './modules/scrollHint';
import { sliderShopMv } from './modules/sliderShopMv';
import { spreadImg } from './modules/spreadImg';
import { tabChange } from './modules/tabChange';

// 慣性スクロール
lenisConfig();

// スライダー
sliderShopMv();

// アンカースムース
anchorSmooth();

// パララックス
imgParallax();
spreadImg();

// header関連
hamburgerMenuToggle();

// TOPページアニメーション
indexMvTextAnimation();

// 細かいアニメーション
aosConfig();
headerColorChange();

// タブ切り替え
tabChange();

// お問い合わせ用
selectFirstTextColorChange();

// ページトップボタンの表示切り替え
pageTop();

// SPのテーブルなどにスクロールを促すアニメーション
scrollHint();
